// =====================================
//
//   product banner
//   Author: Gray
//   createtime: 2016 / 09 / 05
//   updatetime: 2016 / 09 / 05
//
// =====================================

window.InifECMobileApp.directive('productBanner', ['$rootScope', function($rootScope) {

	var _dir = {};

	var link = function(scope, element, attrs) {

    	var init = function() {

            if(Array.isArray(scope.productBanner) && scope.productBanner.length > 0){
                createHtml();
            }
    	}

        var createHtml = function() {

            for(var i = 0; i < scope.productBanner.length; i++) {
                var image = scope.productBanner[i];

                image = image.replace('https://', '//');
                image = image.replace('http://', '//');
                image = image.replace('/large', '/medium');
                if(location.protocol.startsWith("file")){
                    image = 'http://' + image;
                }
                var html = '<div class="image" style="background-image: url(' + image + ')"></div>'

                $(element).append(html);
            }

            bindCarousel();
        }

        var bindCarousel = function() {

            $(element).owlCarousel({
                items : 1,
                dots: true,
                dotsContainer : ".pdt-dot-content",
                dotData : true,
            });
        }

        scope.$watchCollection("productBanner", init);

    	//==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================

        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================
        // init();

	};

	_dir.restrict = 'A';
	_dir.scope = {
        productBanner: '='
    };
	_dir.link = link;

	return _dir;

}]);
